import { useMutation } from "@tanstack/react-query";

import { generateSoilSightDetailedAnalysis } from "services";

import { useIsAuthenticated } from "utils";

import { MUTATE_SOIL_SIGHT_DETAILED_ANALYSIS } from "consts";

type GenerateDetailedAnalysisVariables = {
  projectId: string;
  scenarioId: string;
  signal?: AbortSignal;
};

export const useMutateSoilSightDetailedAnalysis = () => {
  const isAuthenticated = useIsAuthenticated();

  return useMutation({
    mutationKey: [MUTATE_SOIL_SIGHT_DETAILED_ANALYSIS],
    mutationFn: ({ projectId, scenarioId, signal }: GenerateDetailedAnalysisVariables) => {
      if (!isAuthenticated) {
        return Promise.reject(new Error("Not Authorized"));
      }
      return generateSoilSightDetailedAnalysis({ body: { projectId, scenarioId }, signal });
    },
  });
};
